import { atom } from "recoil";

interface OnboardingProgress {
  progress: number;
  sectionCount: number;
}

export const onboardingProgressState = atom<OnboardingProgress>({
  key: "onboardingProgressState",
  default: {
    progress: 0,
    sectionCount: 4,
  },
});